import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';

import { IOffer } from '../models';

export const useRecommendedCenters = (ticketId?: number) => {
  const { data, ...args } = useQuery<{ recommendedCenters: IOffer[] }>({
    queryKey: ['recommended-centers', ticketId],
    queryFn: async () => {
      const { data } = await $apiV2.get(`/learning-center-offer/recommended`, { params: { ticket_id: ticketId } });

      return { recommendedCenters: data?.data };
    }
  });

  return { ...data, ...args };
};
